import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MeteoComponent } from './meteo/meteo';
import { CommonModule } from '@angular/common';

@NgModule({
	declarations: [MeteoComponent],
	imports: [CommonModule],
	exports: [MeteoComponent],
	entryComponents: [],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ComponentsModule { }



// WEBPACK FOOTER //
// ./src/components/components.module.ts